import { dashboard } from "./icons";

export const learnersChildren = [
  {
    text: 'Program',
    type: 'item',
    link: '/learners/program',
    isReact: true,
  },
  {
    text: 'Task List',
    type: 'item',
    link: '/learners/task-list',
    isReact: true,
  },
  {
    text: 'Target',
    type: 'item',
    link: '#top',
    isReact: false,
  },
  {
    text: 'Tutors',
    type: 'item',
    link: '/learners/tutors',
    isReact: true,
  },
  {
    text: 'Document Bank',
    type: 'item',
    link: '#top',
    isReact: false,
  },
  {
    text: 'Quick Links',
    type: 'item',
    link: '/learners/quick-links',
    isReact: true,
  },
];

export const sidebarList = [
  {
    text: 'Dashboard',
    type: 'item',
    link: '/',
    isReact: true,
    children: null,
    icon: dashboard,
    isActive: false,
    isDynamic: false,
  },
  {
    text: 'Learners',
    type: 'item',
    link: 'learners-program',
    isReact: false,
    children: learnersChildren,
    icon: dashboard,
    isActive: false,
    isDynamic: false,
  },
  {
    text: 'Organization',
    type: 'item',
    link: '/organization',
    isReact: false,
    children: null,
    icon: dashboard,
    isActive: false,
    isDynamic: false,
  },
];
